import * as React from "react";

import { t } from "@impero-com/common/utils/i18n";
import { Button, InformationModal } from "@impero-com/ui";

interface FailedAssessmentProps<T> {
    descriptions: T[];
    onClickOk: () => void;
    message: (desc: T) => string;
    descriptionSorter: (a: T, b: T) => number;
    body: string;
    title: string;
}

class FailedAssessmentModal<T> extends React.PureComponent<
    FailedAssessmentProps<T>
> {
    render = () => {
        const {
            descriptions,
            onClickOk,
            body,
            message,
            title,
            descriptionSorter,
        } = this.props;
        const sortedDescriptions = descriptions.slice().sort(descriptionSorter);

        return (
            <InformationModal
                open
                onClose={onClickOk}
                type="warning"
                title={title}
                footer={
                    <Button variant="primary" onClick={onClickOk}>
                        {t("Close")}
                    </Button>
                }
            >
                <div>
                    <p>{body}</p>
                    <ul>
                        {sortedDescriptions.map((desc: T, index) => (
                            <li key={index}>{message(desc)}</li>
                        ))}
                    </ul>
                </div>
            </InformationModal>
        );
    };
}

export { FailedAssessmentModal };
